export default __webpack_public_path__ + "static/jennifer-574f132641e93b4a241e6323c1b87367.jpg";